import { useEffect, useState } from 'react';

import { VBasePopover } from '../VBasePopover';
import { joinCn } from '../util';
import VBaseSelectContextProvider from './VBaseSelectContextProvider';
import VBaseSelectItemList from './VBaseSelectItemList';
import type { VBaseSelectProps } from './type';

const VBaseSelect = <M extends boolean = false>({
  children,
  disabled,
  itemList,
  itemListClassName,
  itemListDuration,
  itemListHeight,
  fitContent,
  multiple,
  placeholder,
  readOnly,
  value,
  placement = 'bottom',

  renderItem,
  onChange,
  onItemClick,
  onItemListVisibleChange,
}: VBaseSelectProps<M>) => {
  const baseSelectProps = {
    itemList,
    itemListClassName,
    itemListDuration,
    itemListHeight,
    fitContent,
    multiple,
    placeholder,
    readOnly,
    value,
    renderItem,
    onChange,
    onItemClick,
    onItemListVisibleChange,
  };
  const [visible, setVisible] = useState(false);
  const onItemListClose = () => setVisible(false);

  useEffect(() => {
    onItemListVisibleChange?.(visible);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  return (
    <VBaseSelectContextProvider
      {...baseSelectProps}
      disabled={disabled}
      readOnly={readOnly}
      itemListVisible={visible}
      onItemListClose={onItemListClose}
    >
      <VBasePopover
        className={joinCn(disabled ? 'hidden!' : '')}
        content={() => (
          <div className="border-x border-gray-200 py-2">
            <VBaseSelectItemList />
          </div>
        )}
        disabled={disabled || readOnly}
        duration={itemListDuration}
        placement={placement}
        trigger="click"
        visible={visible}
        onUpdateVisible={setVisible}
      >
        {children}
      </VBasePopover>
    </VBaseSelectContextProvider>
  );
};

export default VBaseSelect;
